// import s from "./LoadingDots.module.scss"

export default function LoadingDots() {
  return (
    <span className="inline-flex text-center items-center leading-7">
      {/* <span className={s.span} />
      <span className={s.span} />
      <span className={s.span} /> */}
    </span>
  )
}
